import { AfterViewInit, ChangeDetectorRef, Component, Inject, OnInit, NgZone } from '@angular/core';
import { MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

// #region Custom Classes

export class CountdownDialogOptions extends MatDialogConfig {
    TitleText?: string;
    MessageText?: string;
    OKText?: string;
    CancelText?: string;
    CountdownTime?: number;
}

// #endregion

@Component({
    selector: 'dialog-countdown-component',
    styleUrls: ['countdown.dialogcomponent.scss'],
    templateUrl: 'countdown.dialogcomponent.html',
})
export class CountdownDialogComponent implements OnInit, AfterViewInit {
    title: string;
    message: string;
    oktext: string;
    canceltext: string;

    curtime: number;
    maxtime: number;
    time: number;
    timerHandle: number | null;
    timeStr: string;

    constructor(
        public dialogRef: MatDialogRef<CountdownDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: CountdownDialogOptions,
        private changeRef: ChangeDetectorRef,
        private ngZone: NgZone
    ) {
        this.title = data?.TitleText || 'Please wait...';
        this.message = data?.MessageText || '';
        this.oktext = data?.OKText || 'OK';
        this.canceltext = data?.CancelText || 'Cancel';
        this.maxtime = data?.CountdownTime != null ? data.CountdownTime : 170;
        this.curtime = this.maxtime;

        this.time = 100;
        this.timerHandle = null;
        this.timeStr = '';
    }

    CancelHandler() {
        // Disable timer, if possible
        if (this.timerHandle) {
            window.clearInterval(this.timerHandle);
        }
        this.dialogRef.close(null);
    }

    private GetTimeString(timeval: number) {
        const result = Math.floor(timeval / 60) + ':' + ('00' + Math.floor(timeval % 60)).slice(-2);

        return result;
    }

    ngOnInit() {}

    ngAfterViewInit() {
        // Initialize ticking to get it rolling
        this.timerHandle = window.setInterval(() => {
            this.Tick();
        }, 1000);
    }

    OKHandler() {
        // Disable timer, if possible
        if (this.timerHandle) {
            window.clearInterval(this.timerHandle);
        }
        this.dialogRef.close(true);
    }

    private Tick() {
        this.curtime--;
        if (this.curtime >= 0) {
            this.time = Math.floor((this.curtime * 100) / this.maxtime);
            this.timeStr = this.GetTimeString(this.curtime);

            this.changeRef.detectChanges();
        } else {
            // Close the dialog automatically as a "cancel"
            this.CancelHandler();
        }
    }
}
